import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { agentOfficeSetupService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type MutationProps = {
	companyId: string;
	templateId: string;
	name: string;
};

const useCopyFeeTemplateMutation = (onSuccess?: Function) => {
	const dispatch = useDispatch();

	return useMutation(
		({ companyId, templateId, name}: MutationProps) => {
			return agentOfficeSetupService
				.copyFeeTemplate(
					companyId,
					templateId,
					name
				);
		},
		{
			onSuccess() {
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useCopyFeeTemplateMutation;
